<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Unidade Temática"
              v-model="form.filters.nome"
              outlined
              dense
              @keyup.enter="buscarUnidadesTematicas"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="Código da Habilidade"
              v-model="form.filters.codigoHabilidade"
              outlined
              dense
              @keyup.enter="buscarUnidadesTematicas"
            ></v-text-field>
          </v-col>
          <sca-select-ativo
            :cols="3"
            :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
            v-model="form.filters.ativo"
          ></sca-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarUnidadesTematicas()"
              ></sca-tooltip>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterUnidadeTematica()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="headers"
        :items="form.lists.listUnidadesTematicas"
        :items-per-page="10"
        :footer-props="$footerProps"
        :no-data-text="this.$user.permissions.includes('unidade.tematica.listar')? dataText: 'Não há registros a serem exibidos.'"
        show-expand
      >
        <template v-slot:[`item.habilidades`]="{ item }">
          {{ item.habilidades.join(' / ') }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="blue-grey lighten-5">
            <p class="ml-4 my-0 text-wrap mx-70vw">{{ item.descricao }}</p>
          </td>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarUnidadeTematica(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterUnidadeTematica(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="`${item.ativo ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.ativo ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`"
            :small="true"
            @click="inativarAtivarUnidadesTematicas(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarUnidadeTematicaDialog
      :visible="dialogManterUnidadeTematica.visible"
      :content="dialogManterUnidadeTematica.content"
      :edit="dialogManterUnidadeTematica.edit"
      @onClose="dialogManterUnidadeTematica.close()"
      @onSave="buscarUnidadesTematicas()"
    ></CadastrarEditarUnidadeTematicaDialog>
    <VisualizarUnidadeTematicaDialog
      :visible="dialogVisualizarUnidadeTematica.visible"
      :content="dialogVisualizarUnidadeTematica.content"
      @onClose="dialogVisualizarUnidadeTematica.close()"
    ></VisualizarUnidadeTematicaDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { UnidadeTematica } from '~/commons/classes/unidade-tematica';
import DataTableMixin from '~/mixins/datatables.mixin'
import UnidadesTematicasService from '~/services/unidades-tematicas.service';
import CadastrarEditarUnidadeTematicaDialog from './dialogs/CadastrarEditarUnidadeTematicaDialog.vue';
import VisualizarUnidadeTematicaDialog from './dialogs/VisualizarUnidadeTematicaDialog.vue';

export default {
  name: "ManterUnidadesTematicasView",
  mixins: [UnidadesTematicasService, DataTableMixin],
  components: {
    CadastrarEditarUnidadeTematicaDialog,
    VisualizarUnidadeTematicaDialog
  },
  data: () => ({
    dialogManterUnidadeTematica: Dialog.Build(),
    dialogVisualizarUnidadeTematica: Dialog.Build(),
    form: {
      filters: {
        nome: null,
        codigoHabilidade: null,
        ativo: null
      },
      lists: {
        listUnidadesTematicas: []
      }
    },
    headers: [
      { text: "Unidade Temática", align: "center", value: "nome" },
      { text: "Código da Habilidade", align: "center", value: "habilidades" },
      { text: "O que será avaliado", align: "center", value: "data-table-expand" },
      { text: "Situação", align: "center", value: "ativo" },
      { text: "Ações", align: "center", value: "acoes", sortable: false }
    ],
    dataText: ''
  }),
  methods: {
    openDialogManterUnidadeTematica(unidade) {
      unidade
        ? this.$visualizarUnidadesTematicas(unidade).then(({ data }) => this.dialogManterUnidadeTematica.open(new UnidadeTematica(data.resposta), true))
        : this.dialogManterUnidadeTematica.open(UnidadeTematica.Build());
    },
    openDialogVisualizarUnidadeTematica(unidade) {
      this.$visualizarUnidadesTematicas(unidade).then(({ data }) => this.dialogVisualizarUnidadeTematica.open(new UnidadeTematica(data.resposta)));
    },
    buscarUnidadesTematicas() {
    console.log();
    
      this.$buscarUnidadesTematicas({ params: this.form.filters }).then(({ data }) => {
        this.form.lists.listUnidadesTematicas = data.itens;
        if(!data.itens?.length) {
          this.dataText = 'Não há registros a serem exibidos.';
        } else {
          this.dataText = '';
        }
      });
    },
    inativarAtivarUnidadesTematicas(unidade) {
      this.$swal({
        text: `Deseja ${unidade.ativo ? "inativar" : "ativar"} o registro?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`
      }).then(() => {
        this.$inativarAtivarUnidadeTematica(unidade.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarUnidadesTematicas();
        });
      });
    },
    resetForm() {
      this.$clearFilters(this.form);
      this.$resetForm();
      this.dataText = '';
    },
  }
};
</script>
